import React from 'react';

import css from './Agencies.module.scss';

interface AgenciesProps {
    agencies: {
        name: string;
    }[];
}

const Agencies = ({agencies}: AgenciesProps) => <span className={css.agencies}>({agencies.map((agency) => agency.name).join(', ')})</span>;

export default Agencies;
